import "./style.less";
import { trans } from "~/utils/trans";

interface INutritionInfo {
	energy: number;
	proteins: number;
	carbohydrates: number;
	fats: number;
	// day = souhrn celeho dne, meal = jedno jidlo
	variant?: "day" | "meal";
	// denni cil kalorii, zobrazi se v souhrnu dne za lomitkem
	goalEnergy?: number;
}

export default function NutritionInfo({
	energy,
	proteins,
	carbohydrates,
	fats,
	variant = "meal",
	goalEnergy = 0,
} : INutritionInfo) {
	const macros = [
		{ label: trans("nutrition.proteins"), short: trans("nutrition.proteinsShort"), value: proteins },
		{ label: trans("nutrition.carbohydrates"), short: trans("nutrition.carbohydratesShort"), value: carbohydrates },
		{ label: trans("nutrition.fats"), short: trans("nutrition.fatsShort"), value: fats },
	];

	if (variant === "day") {
		return <div className="nutritionDay">
			<div className="nutritionDay__energy">
				{Math.round(energy)}
				{ goalEnergy > 0 && <span className="nutritionDay__goal">/{Math.round(goalEnergy)}</span> }
				<span>kcal</span>
			</div>
			<div className="nutritionDay__macros">
				{macros.map(macro => <div className="nutritionDay__macro" key={macro.short}>
					<strong>{Math.round(macro.value)} g</strong>
					<span>{macro.label}</span>
				</div>)}
			</div>
		</div>;
	}

	return <div className="nutritionMeal">
		<span className="nutritionMeal__energy">{Math.round(energy)} kcal</span>
		<span className="nutritionMeal__macros">
			{macros.map(macro => <span className="nutritionMeal__macro" title={macro.label} key={macro.short}>
				{macro.short} {Math.round(macro.value)}
			</span>)}
			<span className="nutritionMeal__unit"></span>
		</span>
	</div>;
}
